import { IconButton, IconButtonColorEnum, LinkCopyIcon } from '@acceso/design-system';

import { useClipboard } from '@/hooks/useClipboad';

type CopyTextButtonProps = {
  content: string;
  message: string;
};

export function CopyTextButton({ content, message }: CopyTextButtonProps) {
  const { callback: copy } = useClipboard({
    notification: {
      title: message,
    },
  });

  return (
    <IconButton onClick={() => copy(content)} color={IconButtonColorEnum.NONE_DEFAULT}>
      <LinkCopyIcon />
    </IconButton>
  );
}
